import React, { useContext, useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import { Button, Form, FormGroup, Label, Col } from "reactstrap";
// import Datepicker from 'react-datepicker';
import Select from "react-select";
import Datetime from "react-datetime";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import { Get, JENIS_DUSUN, Post } from "../../function/Koneksi";
import { generateAlamat } from '../../function/Format';
import { Tanggal } from "../../function/Format";

const ModalSuratKematian = ({
  data,
  optionData,
  setAlert,
  isOpen,
  setIsOpen,
  statusRefresh,
  setStatusRefresh,
  propsData,
  kiosk
}) => {
  const dateFormat = require("dateformat");

  const frmDex = {
    uuid: "",
    id_jenis: "",
    nik_pelapor: "",
    nik: "",
    kk: "",
    nama: "",
    tempat_lahir: "",
    tanggal_lahir: "",
    jenis_kelamin: "",
    pekerjaan: "",
    pendidikan_terakhir: "",
    kewarganegaraan: "",
    agama: "",
    alamat: "",
    alamat_kk: "",
    status_perkawinan: "",

    detail: [],

    waktu_meninggal: "",
	tempat_meninggal: "",
	sebab_meninggal: "",
	tempat_makam: "",
	tanggal_dimakamkan: ""
  };

	const initFormData = {
		frmNik: optionData.frmNik,
		frmNik2: optionData.frmNik2,
    	frmPkr: optionData.frmPkr,
		frmShdk: optionData.frmShdk,
		nikStat: null,
		nikStatMeninggal: null,
		nik2Stat: null,
		detail: [],
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
			dataPelapor: "none",
			dataPenduduk: "none",
			frmPreviewDraft: false,
		},
		meninggal: "none",
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
    // Preview surat
		get_data_surat:[],
		get_jenis_surat: "",
	}

  const [formData, setFormData] = useState(initFormData);
  const [props, setProps] = useState(propsData);
  const [kioskMode, setKioskMode] = useState(kiosk)
  const [dt, setDt] = useState(data ? data : frmDex);

  useEffect(() => {
    if (document.getElementById("modalForm")) {
      document.getElementById("modalForm").reset();
    }

    setDt(data ? data : frmDex);
    setFormData(
      data
        ? {
            ...initFormData,
            nikStat: optionData.nikStat,
            nikStatMeninggal: optionData.nikStatMeninggal,
            frmPkr: optionData.frmPkr,
            meninggal: optionData.meninggal,
            status: optionData.status
          }
        : initFormData
    );
  }, [isOpen]);

  const changeInputText = (e, fld) => {
    setDt({
      ...dt,
      [fld]: e.target.value
    });
  };

  const handleInputChangeNIK = (e, fld) => {
    if (e && kioskMode == false || e && fld == "meninggal") {
      let nikStat = { value: e, label: e };

      Post("penduduk", null, { nik: e }, datanik => {
        let frmNik = [];
        datanik.data.results.data.forEach(dt => {
          frmNik.push({ value: dt.id, label: dt.id + " (" + dt.nama + ")" });
        });

        switch (fld) {
          case "nik":
            setFormData({
              ...formData,
              frmNik,
              nikStat
            });
            break;
          case "meninggal":
            setFormData({
              ...formData,
              frmNik2: frmNik,
              nikStatMeninggal: nikStat
            });
            break;

          default:
            break;
        }
      });
    }
  };

  const getPenduduk = (e, sel, jns) => {
    if (e) {

      if (kioskMode) {
        props.setLoadingPreview(true)
      }
      else{
        setAlert({
          loadingPreview: true
        })
      }

			Get("penduduk/find", e.value, data => {
        if(data.results){
          const alamat = generateAlamat(data.results);
          let alamat_kk = "";
      
          if(data.results.data_kk){
            alamat_kk = data.results.data_kk.alamat
          }
          // 	if(data.results.data_kk){
          // 		alamat_kk = data.results.data_kk.alamat
          // 	}
          // if (localStorage.getItem('JENIS_DESA').toLowerCase() === 'kelurahan') {
          // 	alamat =
          // 		"RT. " +
          // 		data.results.data_kk.data_rt.nama +
          // 		"/RW. " +
          // 		data.results.data_kk.data_rt.data_rw.nama +
          // 		", " +
          // 		data.results.data_kk.data_rt.data_rw.data_keldes.nama +
          // 		", Kec. " +
          // 		data.results.data_kk.data_rt.data_rw.data_keldes
          // 			.data_kecamatan.nama +
          // 		", " +
          // 		data.results.data_kk.data_rt.data_rw.data_keldes
          // 			.data_kecamatan.data_kabkota.nama;
          // } else {
          // 	if (data.results.data_kk.id_rt === '0') {
          // 		alamat = localStorage.getItem('JENIS_DESA') + " " + data.results.data_keldes.nama +
          // 			", Kec. " + data.results.data_keldes.data_kecamatan.nama +
          // 			", " + data.results.data_keldes.data_kecamatan.data_kabkota.nama +
          // 			", " + data.results.data_keldes.data_kecamatan.data_kabkota.data_provinsi.nama;
          // 	} else {
          // 		if(
          // 			data.results.data_kk.data_rt && 
          // 			data.results.data_kk.data_rt.data_rw &&
          // 			data.results.data_kk.data_rt.data_rw.data_dusun &&
          // 			data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes &&
          // 			data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes.data_kecamatan &&
          // 			data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes.data_kecamatan.data_kabkota
          // 		){
          // 			alamat =
          // 				" RT. " +
          // 				data.results.data_kk.data_rt.nama +
          // 				"/RW. " +
          // 				data.results.data_kk.data_rt.data_rw.nama +
          // 				", " + JENIS_DUSUN + " " +
          // 				data.results.data_kk.data_rt.data_rw.data_dusun.nama +
          // 				", " + localStorage.getItem('JENIS_DESA') + " " +
          // 				data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes.nama +
          // 				", Kec. " +
          // 				data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes
          // 					.data_kecamatan.nama +
          // 				", " +
          // 				data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes
          // 					.data_kecamatan.data_kabkota.nama;
          // 		}
          // 		else{
          // 			setAlert({
          // 				loadingPreview: false
          // 			})

          // 			const alertData = {
          // 				show: true,
          // 				basicType: "info",
          // 				basicTitle: "Data Penduduk Tidak Lengkap",
          // 				pesanAlert: "Mohon Perbaiki Data Kependudukan Terlebih Dahulu"
          // 			}
          // 			setAlert(alertData)
          // 		}
          // 	}
          // }

          if (jns === "pelapor") {
            Get("penduduk/kk/" + data.results.id_kk, null, dtkk => {
              let frmNik3 = [];
              dtkk.results.forEach(val => {
                frmNik3.push({
                  value: val.id,
                  label: val.id + " (" + val.nama + ")"
                });
              });

              setFormData({
                ...formData,
                meninggal:"block",
                nikStat: e,
                status: {
                  ...formData.status,
                  dataPelapor: "block",
                },
              });
              setDt({
                ...dt,
                nik: e.value,
                nik_pelapor: e.value,
                kk: data.results.id_kk,
                nama: data.results.nama,
                nama_pemohon: data.results.nama,
                tempat_lahir: data.results.tempat_lahir,
                tanggal_lahir: new Date(data.results.tanggal_lahir),
                pekerjaan: data.results.data_pekerjaan.nama,
                pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
                agama: data.results.data_agama.nama,
                status_perkawinan: data.results.status_perkawinan,
                jenis_kelamin: data.results.jk,
                alamat: alamat,
                alamat_kk: alamat_kk,
                kewarganegaraan: "WNI",
                detail: []
              });
              
              if (kioskMode) {
                props.setLoadingPreview(false)
              }
              else{
                setAlert({
                  loadingPreview: false
                })
              }

              // For testing
              // if (props.selectOnChange2) {
              // 	props.selectOnChange2(dt)
              // }

            });

          } else if (jns === "meninggal") {
            setFormData({
              ...formData,
              nikStatMeninggal: e,
              status: {
                ...formData.status,
                dataPenduduk: "block",
              },
            })
            setDt({
              ...dt,
              nik_meninggal: e.value,
              nama_meninggal: data.results.nama,
              tempat_lahir_meninggal: data.results.tempat_lahir,
              tanggal_lahir_meninggal: new Date(
                data.results.tanggal_lahir
              ),
              pekerjaan_meninggal: data.results.data_pekerjaan.nama,
              pendidikan_terakhir_meninggal: data.results.data_pendidikan_terakhir.nama,
              agama_meninggal: data.results.data_agama.nama,
              status_perkawinan_meninggal: data.results.status_perkawinan,
              jenis_kelamin_meninggal: data.results.jk,
              alamat_meninggal: alamat,
              alamat_kk1: alamat_kk,
              kewarganegaraan_meninggal: 'WNI',
            })

            if (kioskMode) {
              props.setLoadingPreview(false)
            }
            else{
              setAlert({
                loadingPreview: false
              })
            }
          } else if (jns === "meninggal2") {
            setFormData({
              ...formData,
              nik2Stat: e,
              status: {
                ...formData.status,
                dataPenduduk2: "block",
              },
            })
            setDt({
              ...dt,
              nik_meninggal2: e.value,
              nama_meninggal2: data.results.nama,
              tempat_lahir_meninggal2: data.results.tempat_lahir,
              tanggal_lahir_meninggal2: new Date(
                data.results.tanggal_lahir
              ),
              pekerjaan_meninggal2: data.results.data_pekerjaan.nama,
              pendidikan_terakhir_meninggal2: data.results.data_pendidikan_terakhir.nama,
              agama_meninggal2: data.results.data_agama.nama,
              status_perkawinan_meninggal2: data.results.status_perkawinan,
              jenis_kelamin_meninggal2: data.results.jk,
              alamat_meninggal2: alamat,
              alamat_kk2: alamat_kk,
              kewarganegaraan2: 'WNI',
            })
            
            if (kioskMode) {
              props.setLoadingPreview(false)
            }
            else{
              setAlert({
                loadingPreview: false
              })
            }
            
          } else if (jns === "pengikut") {
            let detail = dt.detail
            detail.push({
              nik: e.value,
              nama: data.results.nama,
              jenis_kelamin: data.results.jk,
              tanggal_lahir: data.results.tanggal_lahir,
              tempat_lahir: data.results.tempat_lahir,
              pekerjaan: data.results.data_pekerjaan.nama,
              // shdk: formData.frmShdk[data.results.shdk],
              alamat: alamat,
              alamat_kk: alamat_kk,
              shdk: data.results.data_shdk.nama,
              keterangan: "",
            })

            setDt({
              ...dt,
              detail
            })

            if (kioskMode) {
              props.setLoadingPreview(false)
            }
            else{
              setAlert({
                loadingPreview: false
              })
            }

            // For testing
            // if (this.props.getListNIK3) {
            // 	this.props.getListNIK3(frmNik3)
            // }
          }
        }
        else{
          if (kioskMode) {
            props.setLoadingPreview(false)
          }
          else{
            setAlert({
              loadingPreview: false
            })
          }
        }
      });
    } else {
      switch (jns) {
        case "pelapor":
          setDt({
            ...dt,
            nama_meninggal:'',
            tempat_lahir_meninggal:'',
            tanggal_lahir_meninggal:'',
            waktu_meninggal: "",
            tempat_meninggal: "",
            sebab_meninggal: "",
            tempat_makam: "",
            tanggal_dimakamkan: "",
          })
          setFormData({
            ...formData,
            status: {
              ...formData.status,
              dataPelapor: "none",
              dataPenduduk:"none",
            },
            meninggal:"none",
            meninggal2:"none",
            nikStat: null,
            nikStatMeninggal: null,
          });
          break;
        case "meninggal":
          setDt({
            ...dt,
			waktu_meninggal: "",
			tempat_meninggal: "",
			sebab_meninggal: "",
			tempat_makam: "",
			tanggal_dimakamkan: "",
          });
          setFormData({
            ...formData,
            status: {
              ...formData.status,
              dataPenduduk: "none"
            },
            nikStatMeninggal: null,
          });
          break;
        default:
          break;
      }
    }
  };

  const simpan = e => {
    e.preventDefault();

    if (kioskMode){
      props.setLoadingPreview(true)
    }
    else{
      setAlert({
        loadingPreview: true
      })
    }

    let validasiMeninggal = false;
    
    if(formData.nikStatMeninggal){
      if(document.getElementById("tempat_meninggal").value && dt.waktu_meninggal && dt.tanggal_dimakamkan ){
        validasiMeninggal = true
      }
    }

    if (formData.nikStat && formData.nikStatMeninggal && validasiMeninggal) {

		let bodyRaw = {
			...dt,
			tanggal_lahir: dateFormat(new Date(dt.tanggal_lahir), "yyyy-mm-dd"),
			tujuan_pembuatan:'-',
		};

		let detail_surat = {
			nama: dt.nama_meninggal,
			nik: dt.nik_meninggal,
			jenis_kelamin: dt.jenis_kelamin_meninggal,
			tempat_lahir: dt.tempat_lahir_meninggal,
			tanggal_lahir: dateFormat(new Date(dt.tanggal_lahir_meninggal), "yyyy-mm-dd"),
			pekerjaan: dt.pekerjaan_meninggal,
			agama: dt.agama_meninggal,
			alamat: dt.alamat_meninggal,
      alamat_kk: dt.alamat_kk1,
			waktu_meninggal: dateFormat(new Date(dt.waktu_meninggal),"yyyy-mm-dd"),
			tempat_meninggal: dt.tempat_meninggal,
			sebab_meninggal: dt.sebab_meninggal,
			tempat_makam: document.getElementById("tempat_makam").value,
			tanggal_dimakamkan: dateFormat(new Date(dt.tanggal_dimakamkan),"yyyy-mm-dd"),
		};

		// Set Detail Surat pada BodyRaw
		bodyRaw = {
			...bodyRaw,
			detail_surat: JSON.stringify(detail_surat),
		}

		if (dt.uuid === "") {
			if (kioskMode) {
				bodyRaw.id_jenis = props.id_jenis
			} else {
				bodyRaw.id_jenis = props.location.state.uuid
			}
		}

		let psn = "";
		let resstat = 204;
		let metode = "create";
		if (bodyRaw.uuid === "") {
			psn = "Tambah";
			resstat = 201;
			bodyRaw.uuid = null;
		} else {
			psn = "Ubah";
			resstat = 200;
			metode = "update";
		}
      
		Post(
			"surat-keterangan/grup/" + metode,
			bodyRaw.uuid,
			bodyRaw,
			res => {
			// For testing
			if (props.resSubmit) {
				props.resSubmit(res.status);
			}
			// this.tutupForm();
			setFormData({
				...formData,
				status: {
          ...formData.status,
          btnForm: false,
          form: false
				}
			});
			setIsOpen(false);

			if (kioskMode) {
        if (res.status === resstat) {
          let dataAntrian = {
            nama: props.data.results.nama,
            nik: props.data.results.id,
            keterangan: '',
            uuid_surat:res.data.results.uuid_surat,
            kode_surat:res.data.results.kode_surat,
          };
  
          // Set Data Surat
          props.getDataSurat(res.data.results);
  
          setTimeout(function () {
            Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {
              
              props.setLoadingPreview(false)

              if (res2.code === 201) {
                props.getAntrian('Surat Keterangan Kematian V2', 'berhasil', false, dataAntrian);
              }
              else {
                props.getAntrian('Surat Keterangan Kematian V2', 'gagal');
              }
            });
          }.bind(this),1000)
        }
        else{
          props.setLoadingPreview(false)
          props.getAntrian('Surat Keterangan Kematian V2', 'gagal');
        }
			} else {
        if (res.status === resstat) {
          const alertData = {
            get_data_surat:{
              uuid_surat:res.data.results.uuid_surat,
              kode_surat:res.data.results.kode_surat,
            },
            status:{
              frmPreviewDraft: true,
              jenis_form: psn,
            }
            // show: true,
            // basicType: "success",
            // basicTitle: "Data Surat Keterangan Kematian V2",
            // pesanAlert: "Berhasil " + psn + " Data",
            // successAlert: true
          };
          setAlert({
            loadingPreview: false
          })
          setAlert(alertData);
				} else {
          const alertData = {
            show: true,
            basicType: "danger",
            basicTitle: "Data Surat Keterangan Kematian",
            pesanAlert: "Gagal " + psn + " Data"
          };
          setAlert({
            loadingPreview: false
          })
          setAlert(alertData);
				}
				// Refresh list
				setStatusRefresh(true);
			}
			}
		);
    } else {
      if (kioskMode){
				props.getAntrian('Surat Keterangan Kematian V2', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
        setAlert({
          loadingPreview: false
        })
				setAlert(alertData)
			}
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      style={{
        maxwidth: "unset"
      }}
      styles={{
      	// modal: {
      		width: '100%',
      		// minWidth: '301px'
      	// }
      }}
    >
      <Form data-testid="form-create" className="theme-form" onSubmit={simpan}>
        <div className="modal-header">
          <h5 className="modal-title">
            {dt.uuid == "" ? "Tambah" : "Edit"} Surat Keterangan Kematian
          </h5>
        </div>
        <div className="modal-body">
          <p>
            Data identitas akan terisi secara otomatis saat NIK dipilih. Jika
            ada ketidak sesuaian data, silakan ubah di data master penduduk.
          </p>
          <input
            className="form-control"
            id="uuid"
            type="hidden"
            placeholder=""
            defaultValue={dt.uuid}
          />
          <FormGroup className="row">
            <Col sm="12">
              <Label className="col-form-label" htmlFor="nik">
                <b>NIK Penduduk</b>
              </Label>
              <div data-testid="selectNIK">
                <Select
                  inputId="nik"
                  classNamePrefix="select"
                  onChange={e => {
                    getPenduduk(e, "nik", "pelapor");
                  }}
                  defaultValue={formData.nikStat}
                  value={formData.nikStat}
                  name="NIK"
                  options={formData.frmNik}
                  placeholder="Pilih NIK"
                  onInputChange={e => handleInputChangeNIK(e, "nik")}
                  isClearable
                />
              </div>
            </Col>
          </FormGroup>
          <div style={{ display: formData.status.dataPelapor }}>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="col-form-label" htmlFor="inputEmail3">
                  <b>Nama Penduduk</b>
                </Label>
                <input
                  className="form-control"
                  id="nama"
                  type="text"
                  placeholder="Nama Pemohon"
                  value={dt.nama}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className=" col-form-label" htmlFor="inputEmail3">
                  <b>Tempat Lahir</b>
                </Label>
                <input
                  className="form-control"
                  id="tempat_lahir"
                  type="text"
                  placeholder="Tempat Lahir"
                  value={dt.tempat_lahir}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="col-form-label" htmlFor="inputEmail3">
                  <b>Tanggal Lahir</b>
                </Label>
                <input
                  className="form-control"
                  id="tanggal_lahir"
                  type="text"
                  placeholder="Tanggal Lahir"
                  value={new Date(dt.tanggal_lahir).toLocaleDateString("id-ID")}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className=" col-form-label" htmlFor="inputEmail3">
                  <b>Alamat</b>
                </Label>
                <input
                  className="form-control"
                  id="alamat_kk"
                  type="text"
                  // placeholder="Tempat Lahir"
                  value={dt.alamat_kk}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
              </Col>
            </FormGroup>
            <FormGroup className="row">
              <Col sm="12">
                <Label className=" col-form-label" htmlFor="inputEmail3">
                  <b>Wilayah</b>
                </Label>
                <input
                  className="form-control"
                  id="alamat"
                  type="text"
                  // placeholder="Tempat Lahir"
                  value={dt.alamat}
                  readOnly
                  style={{ backgroundColor: "#c9d1d8" }}
                  disabled
                />
                <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
              </Col>
            </FormGroup>
          </div>
          <div style={{ display: formData.meninggal }}>
            <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
              <b>Data Penduduk Meninggal</b>
            </div>
            <FormGroup className="row">
              <Col sm="12">
                <Label className="] col-form-label" htmlFor="nik_meninggal">
                  <b>NIK Penduduk</b>
                </Label>
                <div data-testid="selectNIK2">
                  <Select
                    inputId="nik_meninggal"
                    classNamePrefix="select"
                    onChange={e => {
                      getPenduduk(e, "nik", "meninggal");
                    }}
                    defaultValue={formData.nikStatMeninggal}
                    value={formData.nikStatMeninggal}
                    name="NIK2"
                    options={formData.frmNik2}
                    placeholder="Pilih NIK"
                    onInputChange={e => handleInputChangeNIK(e, "meninggal")}
                    isClearable
                  />
                </div>
              </Col>
            </FormGroup>
            <div style={{ display: formData.status.dataPenduduk }}>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Nama Penduduk</b>
                  </Label>
                  <input
                    className="form-control"
                    id="nama_meninggal"
                    type="text"
                    placeholder="Nama Pemohon"
                    value={dt.nama_meninggal}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tempat Lahir</b>
                  </Label>
                  <input
                    className="form-control"
                    id="tempat_lahir_meninggal"
                    type="text"
                    placeholder="Tempat Lahir"
                    value={dt.tempat_lahir_meninggal}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tanggal Lahir</b>
                  </Label>
                  <input
                    className="form-control"
                    id="tanggal_lahir_meninggal"
                    type="text"
                    placeholder="Tanggal Lahir"
                    value={new Date(dt.tanggal_lahir_meninggal).toLocaleDateString(
                      "id-ID"
                    )}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Alamat</b>
                  </Label>
                  <input
                    className="form-control"
                    id="alamat_kk1"
                    type="text"
                    placeholder="Alamat"
                    value={dt.alamat_kk1}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Wilayah</b>
                  </Label>
                  <input
                    className="form-control"
                    id="alamat_meninggal"
                    type="text"
                    placeholder=""
                    value={dt.alamat_meninggal}
                    readOnly
                    style={{ backgroundColor: "#c9d1d8" }}
                    disabled
                  />
                <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tanggal Meninggal</b>
                  </Label>
                  <Datetime
                    inputProps={{
                      "data-testid": "waktu_meninggal",
                      placeholder: "Tanggal Meninggal",
                      // required: true
                    }}
                    inputId="waktu_meninggal"
                    name="waktu_meninggal"
                    id="waktu_meninggal"
                    locale="id-ID"
                    dateFormat="DD/MM/yyyy"
                    timeFormat={false}
                    input={true}
                    closeOnTab={true}
                    initialValue={new Date(dt.waktu_meninggal)}
                    value={new Date(dt.waktu_meninggal)}
                    required
                    // required={formData.status.dataPenduduk !== "none" ? true : false}
                    onChange={date => {
                      if (typeof date._isValid !== "undefined") {
                        let tgl = date.format("YYYY-MM-DD");
                        setDt({
                          ...dt,
                          waktu_meninggal: new Date(tgl)
                        });
                      }
                    }}
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Meninggal di</b>
                  </Label>
                  <input
                    data-testid="tempat meninggal"
                    name="tempat_meninggal"
                    className="form-control"
                    id="tempat_meninggal"
                    type="text"
                    placeholder="Tempat Meninggal"
                    defaultValue={dt.tempat_meninggal}
                    required={
                      formData.status.dataPenduduk !== "none" ? true : false
                    }
					onChange={e => changeInputText(e, "tempat_meninggal")}
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Sebab Meninggal</b>
                  </Label>
                  <input
                    data-testid="sebab meninggal"
                    name="sebab_meninggal"
                    className="form-control"
                    id="sebab_meninggal"
                    type="text"
                    placeholder="Sebab Meninggal"
                    defaultValue={dt.sebab_meninggal}
                    required={
                      formData.status.dataPenduduk !== "none" ? true : false
                    }
					onChange={e => changeInputText(e, "sebab_meninggal")}
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Dimakamkan di</b>
                  </Label>
                  <input
                    data-testid="tempat_makam"
                    name="tempat_makam"
                    className="form-control"
                    id="tempat_makam"
                    type="text"
                    placeholder="Dimakamkan di"
                    defaultValue={dt.tempat_makam}
                    required={
                      formData.status.dataPenduduk !== "none" ? true : false
                    }
					onChange={e => changeInputText(e, "tempat_makam")}
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row">
                <Col sm="12">
                  <Label className="col-form-label" htmlFor="inputEmail3">
                    <b>Tanggal Dimakamkan</b>
                  </Label>
                  <Datetime
                    inputProps={{
                      "data-testid": "tanggal_dimakamkan",
                      placeholder: "Tanggal dimakamkan",
                      // required: true
                    }}
                    inputId="tanggal_dimakamkan"
                    name="tanggal_dimakamkan"
                    id="tanggal_dimakamkan"
                    locale="id-ID"
                    dateFormat="DD/MM/yyyy"
                    timeFormat={false}
                    input={true}
                    closeOnTab={true}
                    initialValue={new Date(dt.tanggal_dimakamkan)}
                    value={new Date(dt.tanggal_dimakamkan)}
                    required
                    // required={formData.status.dataPenduduk !== "none" ? true : false}
                    onChange={date => {
                      if (typeof date._isValid !== "undefined") {
                        let tgl = date.format("YYYY-MM-DD");
                        setDt({
                          ...dt,
                          tanggal_dimakamkan: new Date(tgl)
                        });
                      }
                    }}
                  />
                </Col>
              </FormGroup>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-warning"
            onClick={() => {
              // Tutup modal
              setFormData({
                ...formData,
                status: {
                  ...formData.status,
                  form: false,
                  frmPreviewDraft: false,
					        jenis_form: '',
                }
              });
              setIsOpen(false);
            }}
          >
            Tutup
          </button>
          <button
            data-testid="btnSubmitCreate"
            type="submit"
            className="btn btn-primary-custom"
            // disabled={formData.status.btnForm}
          >
            Simpan
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalSuratKematian;
